import { crearTabla } from '@plataforma/ui';

import { listarAuditoriaBackoffice } from '../api/backoffice.js';
import { exigirSuperAdmin } from '../guardas.js';

import { crearPaginacion, estadoCarga, estadoError, fechaHora } from './backoffice-ui.js';
import { montarShell } from './shell.js';

export async function vistaAuditoria(contenedorRaiz) {
  if (!exigirSuperAdmin()) return;

  const contenido = montarShell(contenedorRaiz, '/auditoria');
  const estadoVista = { entidad: '', pagina: 1 };

  contenido.innerHTML = `
    <div class="pf-backoffice-header">
      <div>
        <h1>Auditoría</h1>
        <p class="pf-texto-suave">Quién hizo qué, sobre qué, cuándo, antes/después y motivo cuando existe.</p>
      </div>
    </div>
    <form class="pf-tarjeta pf-backoffice-toolbar" id="pf-filtros-auditoria">
      <div class="pf-campo">
        <label for="pf-auditoria-entidad">Entidad</label>
        <select id="pf-auditoria-entidad">
          <option value="">Todas</option>
          <option value="empresa">Empresa</option>
          <option value="plan">Plan</option>
          <option value="usuario_plataforma">Usuario</option>
          <option value="solicitud_contratacion">Contratación</option>
          <option value="pago">Pago</option>
          <option value="dominio">Dominio</option>
        </select>
      </div>
      <button type="submit" class="pf-boton pf-boton--secundario">Filtrar</button>
    </form>
    <div id="pf-auditoria-tabla">${estadoCarga()}</div>
  `;

  contenido.querySelector('#pf-filtros-auditoria').addEventListener('submit', async (evento) => {
    evento.preventDefault();
    estadoVista.entidad = contenido.querySelector('#pf-auditoria-entidad').value;
    estadoVista.pagina = 1;
    await cargar(contenido, estadoVista);
  });

  await cargar(contenido, estadoVista);
}

async function cargar(contenido, estadoVista) {
  const destino = contenido.querySelector('#pf-auditoria-tabla');
  destino.innerHTML = estadoCarga();

  const { data, error, count } = await listarAuditoriaBackoffice(estadoVista);
  if (error) {
    destino.innerHTML = estadoError('No se pudo cargar auditoría.');
    return;
  }

  destino.innerHTML = '';
  destino.appendChild(
    crearTabla({
      filaVacia: 'No hay eventos de auditoría.',
      columnas: [
        { titulo: 'Fecha', render: (fila) => fechaHora(fila.creado_en) },
        { titulo: 'Empresa', render: (fila) => fila.empresa?.nombre ?? '—' },
        { clave: 'accion', titulo: 'Acción' },
        { clave: 'entidad', titulo: 'Entidad' },
        { titulo: 'Motivo', render: (fila) => fila.detalle?.motivo ?? '—' },
        { titulo: 'Detalle', render: (fila) => resumirDetalle(fila.detalle) },
      ],
      filas: data ?? [],
    }),
  );
  destino.appendChild(
    crearPaginacion({
      total: count ?? 0,
      pagina: estadoVista.pagina,
      alCambiar: async (pagina) => {
        estadoVista.pagina = pagina;
        await cargar(contenido, estadoVista);
      },
    }),
  );
}

function resumirDetalle(detalle) {
  if (!detalle || typeof detalle !== 'object') return '—';
  if (detalle.tipo_cambio) return detalle.tipo_cambio;
  if (detalle.nuevo?.estado) return `Estado: ${detalle.nuevo.estado}`;
  if (detalle.plan_nuevo?.nombre) return `Plan: ${detalle.plan_nuevo.nombre}`;
  return Object.keys(detalle).slice(0, 4).join(', ') || '—';
}
